import { ResourceDataType } from "@/store/live-usage-mgmt/utils/types/types";

export const isIncludingReadOnlyAccounts = (resources?: ResourceDataType[]) => {
  if (!resources) {
    return;
  }

  return resources.some(
    (resource) => resource.resource.account.provider_access_type === "read",
  );
};
